// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Schematisation
 */
export interface Schematisation {
  /**
   *
   */
  name: string;
  /**
   *
   */
  id?: number | null;
  /**
   *
   */
  version?: number | null;
  /**
   *
   */
  revisionId?: number | null;
  /**
   *
   */
  modelId?: number | null;
}

/**
 * Check if a given object implements the Schematisation interface.
 */
export function instanceOfSchematisation(value: object): value is Schematisation {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function SchematisationFromJSON(json: any): Schematisation {
  return SchematisationFromJSONTyped(json, false);
}

export function SchematisationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Schematisation {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    id: json["id"] === undefined ? undefined : json["id"] === null ? null : json["id"],
    version:
      json["version"] === undefined ? undefined : json["version"] === null ? null : json["version"],
    revisionId:
      json["revision_id"] === undefined
        ? undefined
        : json["revision_id"] === null
        ? null
        : json["revision_id"],
    modelId:
      json["model_id"] === undefined
        ? undefined
        : json["model_id"] === null
        ? null
        : json["model_id"],
  };
}

export function SchematisationToJSON(json: any): Schematisation {
  return SchematisationToJSONTyped(json, false);
}

export function SchematisationToJSONTyped(
  value?: Schematisation | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    id: value["id"],
    version: value["version"],
    revision_id: value["revisionId"],
    model_id: value["modelId"],
  };
}
